class StockBaseInfo {
    constructor({ id, symbol, companyName, currency, price }) {
        this._id = id;
        this._symbol = symbol;
        this._companyName = companyName;
        this._currency = currency;
        this._price = price;
    }

    get id() { return this._id; }
    get symbol() { return this._symbol; }
    get companyName() { return this._companyName; }
    get currency() { return this._currency; }
    get price() { return this._price; }

    set id(value) { this._id = value; }
    set symbol(value) { this._symbol = value; }
    set companyName(value) { this._companyName = value; }
    set currency(value) { this._currency = value; }
    set price(value) { this._price = value; }
}
export default StockBaseInfo;